import React from "react";
import { Sparkles, Globe2, Tag, Radio } from "lucide-react";
import { useAppState } from "@/context/AppState";
import { useI18n } from "@/context/I18nContext";
import LangSwitcher from "@/components/LangSwitcher";

const TABS = [
  { key: "moods", i18n: "nav.moods", icon: Sparkles },
  { key: "places", i18n: "nav.places", icon: Globe2 },
  { key: "genres", i18n: "nav.genres", icon: Tag },
];

export default function TopNav() {
  const { tab, setTab } = useAppState();
  const { t } = useI18n();
  return (
    <div
      data-testid="top-nav"
      className="flex items-center border-b border-[var(--voix-border)] px-4 md:px-6 h-14 bg-[var(--voix-bg)]/70 backdrop-blur-sm sticky top-0 z-10"
    >
      <a
        data-testid="voix-wordmark"
        href="/"
        className="flex items-center gap-2 mr-6 pr-6 border-r border-[var(--voix-border)] h-full"
      >
        <span className="w-7 h-7 rounded-md bg-cyan-500/20 border border-cyan-500/40 flex items-center justify-center lg:hidden">
          <Radio size={13} className="text-cyan-300" />
        </span>
        <span className="font-heading text-lg font-black tracking-tight leading-none">
          VOIX<span className="text-cyan-400">.</span>
        </span>
      </a>

      <div className="flex items-center gap-1 h-full">
        {TABS.map((tt) => {
          const Icon = tt.icon;
          const active = tab === tt.key;
          return (
            <button
              key={tt.key}
              data-testid={`tab-${tt.key}`}
              onClick={() => setTab(tt.key)}
              className={`relative flex items-center gap-2 px-4 h-full font-mono-tech text-[10px] uppercase tracking-[0.28em] transition ${
                active ? "text-white" : "text-slate-500 hover:text-slate-300"
              }`}
            >
              <Icon size={13} strokeWidth={2} />
              <span>{t(tt.i18n)}</span>
              {active && <span className="absolute left-3 right-3 bottom-0 h-[2px] bg-cyan-400" />}
            </button>
          );
        })}
      </div>

      <div className="ml-auto flex items-center gap-3">
        <span className="hidden xl:inline font-mono-tech text-[9px] uppercase tracking-[0.35em] text-slate-600">
          {t("nav.tagline")}
        </span>
        <LangSwitcher />
      </div>
    </div>
  );
}
